import React, { useMemo } from 'react';
import { Avatar, AvatarContainer, Initials } from './VoiceFocusedAvatar.styled';
import useStreamVolume from '@core/components/MicrophoneStreamProvider/useStreamVolume';

/** @type {React.FC<{name?: string; audioStream?: MediaStream;}>} */
const VoiceFocusedAvatar = ({ name, audioStream }) => {
  const initials = useMemo(() => {
    if (!name) return 'NA';
    return name
      .split(' ')
      .map((n) => n[0])
      .join('');
  }, [name]);

  const volume = useStreamVolume(audioStream);

  let scale = 1;
  if (volume > 0.01) {
    const multiplier = 0.8 * volume;
    scale += multiplier;
    scale = Math.min(1.5, scale);
  }

  return (
    <AvatarContainer>
      <Avatar
        style={{
          transform: 'scale(' + scale + ')',
        }}
      ></Avatar>
      <Initials>{initials}</Initials>
    </AvatarContainer>
  );
};

export default VoiceFocusedAvatar;
